import React, { useState, useEffect } from "react";
import { getUsersWithMissingTimecards } from "../Api/DashboardTicketTimecard";
import { Container, Card, Badge, Spinner, Alert, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";

function DashboardTicketTimecard() {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [analysisPeriod, setAnalysisPeriod] = useState("");

  useEffect(() => {
    const fetchMissingTimecardsData = async () => {
      try {
        setLoading(true);
        const response = await getUsersWithMissingTimecards();

        if (!response.data || !response.data.length) {
          throw new Error(response.message || "No users with missing timecards found");
        }

        setUsersData(response.data);
        setAnalysisPeriod(response.message);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching missing timecards data:", err);
        setError(err.message);
        setLoading(false);
        setUsersData([]);
        toast.error(err.message || "Failed to load missing timecards data");
      }
    };

    fetchMissingTimecardsData();
  }, []);

  const getFontSize = (count, minCount, maxCount) => {
    const minSize = 14;
    const maxSize = 28;
    const range = maxCount - minCount || 1;
    return minSize + ((count - minCount) / range) * (maxSize - minSize);
  };

  if (loading) {
    return (
      <div className="main-content expand">
        <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
          <Sample14 />
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <Alert variant="danger" className="text-center">
            <Alert.Heading>Error loading missing timecards data</Alert.Heading>
            <p>{error}</p>
          </Alert>
        </Container>
      </div>
    );
  }

  const minMissingDays = Math.min(...usersData.map(u => u.missingDaysCount));
  const maxMissingDays = Math.max(...usersData.map(u => u.missingDaysCount));

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="text-center mb-4">Pending Timecards Overview</h2>
        
        {analysisPeriod && (
          <p className="text-center mb-4">{analysisPeriod}</p>
        )}

        {usersData.length > 0 ? (
          <Card className="mb-4">
            <Card.Body>
              {/* Word Cloud */}
              <div className="d-flex flex-wrap justify-content-center gap-2 p-3">
                {usersData.map((user, index) => {
                  const fontSize = getFontSize(user.missingDaysCount, minMissingDays, maxMissingDays);
                  const isTopUser = index < 3;

                  return (
                    <Badge
                      key={user.username}
                      pill
                      bg={isTopUser ? "primary" : "secondary"}
                      className="m-1 p-2"
                      style={{
                        fontSize: `${fontSize}px`,
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => console.log(`Clicked ${user.username}`)}
                    >
                      {user.username} ({user.missingDaysCount})
                    </Badge>
                  );
                })}
              </div>

              {/* Detailed breakdown */}
              <h4 className="mt-4 mb-3">Pending Timecards Details</h4>
              <Row xs={1} md={2} lg={3} className="g-4">
                {usersData.map((user, index) => (
                  <Col key={user.username}>
                    <Card className={index < 3 ? "border-primary" : ""}>
                      <Card.Body>
                        <div className="d-flex justify-content-between">
                          <Card.Title>
                            {index + 1}. {user.username}
                          </Card.Title>
                          <Badge bg="danger" pill>
                            Missing: {user.missingDaysCount} days
                          </Badge>
                        </div>
                        <Card.Text>
                          <small className="text-muted">
                            Last Entry: {user.lastEntryDate || "No entries found"}
                          </small>
                        </Card.Text>
                        {user.email && (
                          <Card.Text>
                            <small>Email: {user.email}</small>
                          </Card.Text>
                        )}
                        {user.missingDates?.length > 0 && (
                          <Card.Text>
                            <small>
                              Missing Dates: {user.missingDates.slice(0, 3).join(", ")}
                              {user.missingDates.length > 3 ? ` +${user.missingDates.length - 3} more` : ""}
                            </small>
                          </Card.Text>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        ) : (
          <Alert variant="info" className="text-center">
            All timecards are up to date!
          </Alert>
        )}
      </Container>
    </div>
  );
}

export default DashboardTicketTimecard;